(function() { window.GUID_9d0262ea_b45e_4068_b1b2_eb85261a5485 = { getGuid: function() { return "9d0262ea-b45e-4068-b1b2-eb85261a5485"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Popover {
            constructor(referenceElement, url, data, withOverlay = true, allowClickOnTarget = false, freezeUI = false, content = null) {
                this.referenceElement = referenceElement;
                this.url = url;
                this.data = data;
                this.withOverlay = withOverlay;
                this.allowClickOnTarget = allowClickOnTarget;
                this.freezeUI = freezeUI;
                this.content = content;
                this.scrollToReferenceElement = false;
                this.cleanupAutoUpdate = null;
                this.autoUpdateTick = 0;
                if (this.freezeUI) {
                    this.withOverlay = true;
                    this.scrollToReferenceElement = true;
                }
                this.popoverElement = document.createElement("div");
                this.popoverElement.className = "popover";
                this.popoverHeaderElement = document.createElement("div");
                this.popoverHeaderElement.className = "popover-header";
                this.popoverHeaderElement.innerHTML = `<div class="ic-cs-times ico-div"></div>`;
                this.arrowElement = document.createElement("div");
                this.arrowElement.className = "popover-arrow";
                this.popoverElement.prepend(this.popoverHeaderElement);
                this.popoverElement.appendChild(this.arrowElement);
                document.body.appendChild(this.popoverElement);
                if (this.withOverlay) {
                    this.overlayElement = document.createElement("div");
                    this.overlayElement.className = "popover-overlay";
                    this.overlayElement.addEventListener("click", () => this.hide());
                    this.referenceOverlayElement = document.createElement("div");
                    this.referenceOverlayElement.className = "popover-reference-overlay";
                    this.referenceOverlayElement.addEventListener("click", () => {
                        this.hide();
                        if (this.allowClickOnTarget) {
                            this.referenceElement.click();
                        }
                    });
                }
                this.popoverElement.addEventListener("click", () => this.hide());
            }
            debugLog(message, data) {
                if (!Popover.debugLogsEnabled) {
                    return;
                }
                const referenceRect = this.referenceElement
                    ? this.referenceElement.getBoundingClientRect()
                    : null;
                console.log(`[Popover] ${message}`, {
                    data,
                    reference: {
                        id: this.referenceElement ? this.referenceElement.id : null,
                        className: this.referenceElement
                            ? this.referenceElement.className
                            : null,
                        isConnected: this.referenceElement
                            ? this.referenceElement.isConnected
                            : false,
                        rect: referenceRect
                            ? {
                                top: referenceRect.top,
                                left: referenceRect.left,
                                width: referenceRect.width,
                                height: referenceRect.height,
                            }
                            : null,
                    },
                    popover: {
                        isConnected: this.popoverElement ? this.popoverElement.isConnected : false,
                        display: this.popoverElement ? this.popoverElement.style.display : null,
                        visibility: this.popoverElement
                            ? this.popoverElement.style.visibility
                            : null,
                        opacity: this.popoverElement ? this.popoverElement.style.opacity : null,
                    },
                    viewport: {
                        width: window.innerWidth,
                        height: window.innerHeight,
                        scrollY: window.scrollY,
                    },
                });
            }
            getContent() {
                return new Promise((resolve, reject) => {
                    if (this.content) {
                        return resolve(this.content);
                    }
                    CS.Ajax.Get(this.url, this.data, (response) => {
                        return resolve(response);
                    });
                });
            }
            show() {
                return new Promise((resolve, reject) => {
                    try {
                        this.debugLog("show() called", {
                            withOverlay: this.withOverlay,
                            allowClickOnTarget: this.allowClickOnTarget,
                            freezeUI: this.freezeUI,
                            contentMode: this.content ? "inline" : "ajax",
                            url: this.url,
                        });
                        if (this.scrollToReferenceElement) {
                            CS.DOM.$body.addClass("overflow--hidden");
                        }
                        if (window["FloatingUIDOM"]) {
                            this.getContent().then((content) => {
                                this.debugLog("content resolved", {
                                    contentLength: content ? content.length : 0,
                                });
                                this.popoverElement.innerHTML = content;
                                this.popoverElement.appendChild(this.arrowElement);
                                this.popoverElement.prepend(this.popoverHeaderElement);
                                this.cleanupAutoUpdate = window["FloatingUIDOM"].autoUpdate(this.referenceElement, this.popoverElement, () => {
                                    this.autoUpdateTick++;
                                    const shouldLogTick = this.autoUpdateTick <= 10 || this.autoUpdateTick % 20 === 0;
                                    if (shouldLogTick) {
                                        this.debugLog("autoUpdate tick", {
                                            tick: this.autoUpdateTick,
                                        });
                                    }
                                    window["FloatingUIDOM"]
                                        .computePosition(this.referenceElement, this.popoverElement, {
                                        placement: "top",
                                        middleware: [
                                            window["FloatingUIDOM"].offset(32),
                                            window["FloatingUIDOM"].flip({
                                                padding: {
                                                    top: CS.Views.MasterPage.TopHeight,
                                                    bottom: CS.Views.MasterPage.BottomHeight,
                                                },
                                            }),
                                            window["FloatingUIDOM"].arrow({
                                                element: this.arrowElement,
                                            }),
                                            window["FloatingUIDOM"].hide({
                                                padding: {
                                                    top: CS.Views.MasterPage.TopHeight,
                                                    bottom: CS.Views.MasterPage.BottomHeight,
                                                },
                                            }),
                                        ],
                                    })
                                        .then(({ x, y, middlewareData, placement }) => {
                                        const hideData = middlewareData.hide || {};
                                        const shouldLogPosition = this.autoUpdateTick <= 10 ||
                                            this.autoUpdateTick % 20 === 0 ||
                                            hideData.referenceHidden ||
                                            hideData.escaped;
                                        if (shouldLogPosition) {
                                            this.debugLog("computePosition resolved", {
                                                tick: this.autoUpdateTick,
                                                x: x,
                                                y: y,
                                                placement: placement,
                                                hide: hideData,
                                            });
                                        }
                                        Object.assign(this.popoverElement.style, {
                                            left: `${x}px`,
                                            top: `${y}px`,
                                            position: "absolute",
                                        });
                                        if (this.withOverlay) {
                                            let top = y;
                                            if (placement === "top") {
                                                top += 32 + this.popoverElement.offsetHeight;
                                            }
                                            else {
                                                top -= 32 + this.referenceElement.offsetHeight;
                                            }
                                            const borderRadius = $(this.referenceElement).css("border-radius");
                                            Object.assign(this.referenceOverlayElement.style, {
                                                width: `${this.referenceElement.offsetWidth}px`,
                                                height: `${this.referenceElement.offsetHeight}px`,
                                                top: `${top}px`,
                                                left: `${this.referenceElement.getBoundingClientRect().left}px`,
                                                "border-radius": borderRadius,
                                            });
                                        }
                                        if (middlewareData.arrow) {
                                            const { x: arrowX, y: arrowY } = middlewareData.arrow;
                                            if (placement === "top") {
                                                Object.assign(this.arrowElement.style, {
                                                    left: arrowX != null ? `${arrowX}px` : "",
                                                    top: "",
                                                    bottom: "-24px",
                                                });
                                                this.arrowElement.classList.remove("triangle-top");
                                                this.arrowElement.classList.add("triangle-bottom");
                                            }
                                            else {
                                                Object.assign(this.arrowElement.style, {
                                                    left: arrowX != null ? `${arrowX}px` : "",
                                                    top: "-24px",
                                                    bottom: "",
                                                });
                                                this.arrowElement.classList.remove("triangle-bottom");
                                                this.arrowElement.classList.add("triangle-top");
                                            }
                                        }
                                        if (middlewareData.hide && !this.freezeUI) {
                                            Object.assign(this.popoverElement.style, {
                                                visibility: middlewareData.hide.referenceHidden
                                                    ? "hidden"
                                                    : "visible",
                                            });
                                            this.debugLog("visibility updated from hide middleware", {
                                                tick: this.autoUpdateTick,
                                                referenceHidden: middlewareData.hide.referenceHidden,
                                                escaped: middlewareData.hide.escaped,
                                                finalVisibility: this.popoverElement.style.visibility,
                                            });
                                            if (this.withOverlay) {
                                                Object.assign(this.overlayElement.style, {
                                                    display: middlewareData.hide.referenceHidden
                                                        ? "none"
                                                        : "block",
                                                    "pointer-events": middlewareData.hide
                                                        .referenceHidden
                                                        ? "none"
                                                        : "auto",
                                                });
                                                Object.assign(this.referenceOverlayElement.style, middlewareData.hide.referenceHidden
                                                    ? {
                                                        display: "none",
                                                        "pointer-events": "none",
                                                    }
                                                    : {
                                                        display: "block",
                                                        "pointer-events": "auto",
                                                    });
                                            }
                                        }
                                    });
                                });
                                this.popoverElement.style.display = "block";
                                this.debugLog("popover display set to block");
                                if (this.withOverlay) {
                                    document.body.appendChild(this.overlayElement);
                                    document.body.appendChild(this.referenceOverlayElement);
                                    this.debugLog("overlay elements appended");
                                }
                                setTimeout(() => {
                                    this.referenceOverlayElement.style.opacity = "1";
                                    this.popoverElement.style.opacity = "1";
                                    this.debugLog("opacity transition applied");
                                }, 100);
                                return resolve();
                            });
                        }
                        else {
                            this.debugLog("show() failed because FloatingUIDOM is missing");
                            throw new Error("FloatingUIDOM is not defined");
                        }
                    }
                    catch (error) {
                        this.debugLog("show() caught error", error);
                        if (this.scrollToReferenceElement) {
                            CS.DOM.$body.removeClass("overflow--hidden");
                        }
                        return reject(error);
                    }
                });
            }
            hide() {
                this.debugLog("hide() called");
                this.popoverElement.style.display = "none";
                if (this.scrollToReferenceElement) {
                    CS.DOM.$body.removeClass("overflow--hidden");
                }
                if (this.cleanupAutoUpdate) {
                    this.cleanupAutoUpdate();
                    this.cleanupAutoUpdate = null;
                    this.debugLog("autoUpdate cleanup completed");
                }
                this.popoverElement.style.transition = "opacity 0.2s";
                this.popoverElement.style.opacity = "0";
                CS.Lag("popover", 200, () => {
                    this.popoverElement.remove();
                    this.debugLog("popover removed from DOM");
                    if (this.onHide) {
                        this.onHide();
                    }
                });
                if (this.withOverlay) {
                    if (this.overlayElement && this.overlayElement.parentElement) {
                        this.overlayElement.style.transition = "opacity 0.2s";
                        this.overlayElement.style.opacity = "0";
                        CS.Lag("popover-overlay", 200, () => {
                            this.overlayElement.parentElement.removeChild(this.overlayElement);
                        });
                    }
                    if (this.referenceOverlayElement &&
                        this.referenceOverlayElement.parentElement) {
                        this.referenceOverlayElement.style.transition = "opacity 0.2s";
                        this.referenceOverlayElement.style.opacity = "0";
                        CS.Lag("popover-reference-overlay", 200, () => {
                            this.referenceOverlayElement.parentElement.removeChild(this.referenceOverlayElement);
                        });
                    }
                }
            }
        }
        Popover.debugLogsEnabled = true;
        Controls.Popover = Popover;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=Popover.js.map
